module.exports = __webpack_public_path__ + "img/img_9.945ff307.svg";